import type { TFunction } from 'i18next';
import { svSE } from '@mui/x-data-grid-premium/locales';

/** MUI X's own DataGrid translations, by language. English is the grid's built-in default. */
const GRID_LOCALES: Record<string, object> = { sv: svSE };

type DisplayedRows = { from: number; to: number; count: number; estimated?: number };

/**
 * The DataGrid texts for the active language, as theme overrides for `createTheme`: MUI X's pack for
 * the language, plus what the pack leaves untranslated ("1–3 of 3" in the pagination footer), from
 * the app's own locale files. Applied on the theme, so every grid gets them.
 */
export function dataGridLocale(language: string, t: TFunction): object[] {
  const pack = GRID_LOCALES[language.split('-')[0]];
  const displayedRows = ({ from, to, count, estimated }: DisplayedRows) => {
    const total = count !== -1
      ? count
      : estimated && estimated > to
        ? t('dataGrid.around', { defaultValue: 'around {{estimated}}', estimated })
        : t('dataGrid.moreThan', { defaultValue: 'more than {{to}}', to });
    return t('dataGrid.displayedRows', { defaultValue: '{{from}}–{{to}} of {{total}}', from, to, total });
  };
  return [
    ...(pack ? [pack] : []),
    { components: { MuiDataGrid: { defaultProps: { localeText: { paginationDisplayedRows: displayedRows } } } } },
  ];
}
